import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/vueCookie';
import './plugins/veelidate';
import './permission'; // permission control
import './plugins/charts'; // permission control
import './plugins/Dayjs'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
